import React, { useState } from "react";
import { HeroSection, HeroText, StartButton } from "./styles";
import TabSection from "./TabSection";
// import InfoPopup from "./InfoPopup";
import PrivacyDocPopup from "./PrivacyDocPopup";
import { SCHOOL_SIGNUP_URL } from "../../constants/urls";

const Home: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<string | null>(null);

  const handleStartClick = () => {
    window.open(SCHOOL_SIGNUP_URL, "_self");
  };

  return (
    <div>
      {/* <InfoPopup /> */}
      <PrivacyDocPopup />
      <HeroSection>
        <HeroText>쉽고 빠르고 효과적인{"\n"}무료 보건일지 프로그램</HeroText>
        <StartButton onClick={handleStartClick}>무료로 시작하기</StartButton>
      </HeroSection>
      <TabSection selectedTab={selectedTab} onTabChange={setSelectedTab} />
    </div>
  );
};

export default Home;
